<template>
  <div class="message-contacts">
    <ul class="contact-list">
<li 
  v-for="contact in contacts" 
  :key="contact.id" 
  class="contact-item"
  @click="handleClick(contact)"
>
  <div class="avatar-wrapper">
    <img :src="contact.avatar" class="avatar" />

    <span 
      v-if="getUnreadCount(contact) > 0"
      class="notification-badge"
    >
      {{ getUnreadCount(contact) }}
    </span>
  </div>

  <div class="contact-info">
    <p class="name">{{ contact.name }}</p>
    <p class="preview">{{ contact.lastMessage }}</p>
  </div>

  <button 
    v-if="contact.type === 'user'"
    class="view-btn"
    @click.stop="$emit('open-chat', contact)"
  >
    View Message
  </button>
</li>

    </ul>
  </div>
</template>

<script>
export default {
  name: 'MessageContacts',
  props: {
    contacts: { type: Array, default: () => [] },
    systemPayloadList: Array
  },
  methods: {
    // Extract unread count from either numeric or object format
    getUnreadCount(contact) {
      const userId = window.localStorage.getItem('userId');
      if (!contact.unreadCount) return 0;
      if (typeof contact.unreadCount === 'number') return contact.unreadCount;
      if (typeof contact.unreadCount === 'object') return contact.unreadCount[userId] || 0;
      return 0;
    },
    handleClick(contact) {
      if (contact.type === "system") {
        this.$emit("open-system-popup", this.$props.systemPayloadList);
      } else {
        this.$emit("open-chat", contact);
      }
    }

    }   
}
</script>

<style scoped>
.contact-list { list-style: none; padding: 0; margin: 0; }
.contact-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px;
  border-bottom: 1px solid #eee;
}
.contact-item:hover { background: #f8f8f8; }
/* Avatar + red dot wrapper */
.avatar-wrapper {
  position: relative;
  width: 48px;
  height: 48px;
}
.avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

/* Red notification badge */
.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #f94848ff;
  color: white;
  font-size: 10px;
  font-weight: bold;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-info { flex: 1; margin-left: 10px; }
.name { font-weight: bold; }
.preview { color: gray; font-size: 0.9rem; }
.view-btn {
  padding: 6px 12px;
  border: none;
  background: #FF7222;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
.view-btn:hover { background: #e55a0f; }
</style>



// WEBPACK FOOTER //
// src/components/messagebox/contactlist.vue